<!--
 * @author wendb
 * @date 2023-06-02 11:52
 * @description  角色管理
-->
<template>
  <lsTableLayout>
    <template #search>
      <ListSearchForm ref="searchForm" @onSearch="onSearch" />
    </template>
    <template #btn>
      <lsStatusButton v-show="false">
        <a-button @click="$refs.createModal.show()" v-hasPermi="['system:user:add']" type="primary">新增</a-button>
        <a-button @click="handleDeleteBatch(selectedRowKeys)" :disabled="selectedRowKeys.length === 0" v-hasPermi="['system:role:remove']">删除</a-button>
        <a-button @click="handleExport" v-hasPermi="['system:role:export']">导出</a-button>
      </lsStatusButton>
    </template>
    <div slot="table">
      <ls-api-table
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        :selectedRows.sync="selectedRows"
        :multi-select="true"
        rowKey="roleId"
        :scroll="{ fixScreen: true, x: 1300 }"
        @selectedRowChange="selectedRowChange"
        :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.ROLE_LIST, // 表格方案配置唯一值
              }"
      >
        <!-- 插槽指向状态 -->
        <template slot="status" slot-scope="{ text }">
          <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
          <!-- <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmHandleStatus(record)"
            @cancel="cancelHandleStatus(record)"
          >
            <span slot="title">确认<b>{{ record.status === '1' ? '启用' : '停用' }}</b>{{ record.roleName }}的角色吗?</span>
            <a-switch :checked="record.status == 0" />
          </a-popconfirm> -->
        </template>
        <!-- 更多选择 -->
        <!-- <template slot="action" slot-scope="{ record }">
          <a @click="$refs.createModal.show(record)" v-hasPermi="['system:role:edit']">编辑</a>
          <a-divider type="vertical" />
          <a @click="$refs.createDataScopeForm.handleDataScope(record)" v-hasPermi="['system:role:edit']">数据权限</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" v-hasPermi="['system:role:remove']" @click="handleDelete(record)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template> -->
      </ls-api-table>
      <!-- 创建/编辑角色,单独封装了组件 -->
      <create-form
        ref="createModal"
        @handle-success="onSearch"
      />
      <!-- 分配角色数据权限对话框 -->
      <create-data-scope-form
        ref="createDataScopeForm"
        @ok="onSearch"
      />
    </div>
  </lsTableLayout>
</template>

<script>
import { listRole, delRole, changeRoleStatus } from '@/api/system/role'
import ListSearchForm from './components/ListSearchForm'
import CreateForm from './components/CreateForm'
import CreateDataScopeForm from './components/CreateDataScopeForm'
import { generateLsTableResData } from '@/utils/util.js';

const statusMap = {
  0: {
    status: 'processing',
    text: '正常'
  },
  1: {
    status: 'default',
    text: '停用'
  }
}

export default {
  name: 'Role',
  components: {
    ListSearchForm,
    CreateForm,
    CreateDataScopeForm
  },
  data () {
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(listRole, true),
        pageCurrent: true
      },
      // 表头
      columns: [
        {
          title: '角色编号',
          dataIndex: 'roleId',
          scopedSlots: { customRender: 'roleId' }
        },
        {
          title: '角色名称',
          dataIndex: 'roleName'
        },
        {
          title: '权限字符',
          dataIndex: 'roleKey'
        },
        {
          title: '显示顺序',
          dataIndex: 'roleSort'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '创建时间',
          width: '150',
          dataIndex: 'createTime'
        }
        // {
        //   title: '操作',
        //   width: '150',
        //   dataIndex: 'action',
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      // table加载绑定
      tableLoading: false,
      // 表格数据
      roleList: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        roleName: undefined,
        roleKey: undefined,
        status: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: true,
      // 筛选日期
      dateRange: []
    }
  },
  mounted () {
    this.onSearch();
  },
  // 状态过滤
  filters: {
    statusFilter (type) {
      return statusMap[type].text
    },
    statusTypeFilter (type) {
      return statusMap[type].status
    }
  },
  methods: {
    // 表单搜索
    onSearch (values = {}) {
      const params = { ...values };
      delete params.searchFormLabel;
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      const roleIds = row.roleId || this.ids
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 角色编号为${roleIds}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delRole(roleIds).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch();
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 批量删除按钮操作 */
    handleDeleteBatch (ids) {
      const roleIds = ids
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 角色编号为${roleIds}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delRole(roleIds).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch();
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.download('system/role/export', {
        ...this.queryParams
      }, `角色数据_${new Date().getTime()}.xlsx`)
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch();
    },
    /* 任务状态修改 */
    confirmHandleStatus (row) {
      row.status = row.status === '0' ? '1' : '0'
      const text = row.status === '0' ? '启用' : '停用'
      changeRoleStatus(row.roleId, row.status)
      .then(() => {
        this.$message.success(
          text + '成功',
          3
        )
      }).catch(function () {
        this.$message.error(
          text + '发生异常',
          3
        )
      })
    },
    cancelHandleStatus (row) {
    }
  }
}
</script>
